const getMenuItemsVisibility = () =>
    JSON.parse(localStorage.getItem("menuItemsVisibility") || "{}");


export const GetMenuItemsToHide = () => 
{
    const menuItemsVisibility = getMenuItemsVisibility();
    const menuItemsToHide = [""];

    Object.keys(menuItemsVisibility).forEach((key) => 
    {
        if ( !menuItemsVisibility[key] )
        menuItemsToHide.push(key);
    });

    return menuItemsToHide;
}

export const GetMenuItemsToShow = () => 
    {
        const menuItemsVisibility = getMenuItemsVisibility();
        const menuItemsToShow = [""];
    
        Object.keys(menuItemsVisibility).forEach((key) => 
        {
            if ( menuItemsVisibility[key] )
                menuItemsToShow.push(key);
        });
    
        return menuItemsToShow;
    }

